import { createApi } from "@reduxjs/toolkit/query/react";
import { getLoggerBaseQuery } from "../common.js";
import { vnextFeatureReadV2ApiBaseQuery, TAGS } from "./common.js";
import { LIST_TAG } from "../utils.js";
const expFeatureReadV2Api = createApi({
  reducerPath: "exp_feature_read_v2_rtkquery",
  baseQuery: getLoggerBaseQuery(vnextFeatureReadV2ApiBaseQuery),
  endpoints: () => ({}),
  tagTypes: [LIST_TAG, ...Object.values(TAGS)]
});
export {
  expFeatureReadV2Api
};
//# sourceMappingURL=api.js.map
